var _path, _circle, _circle2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 8.9462C17.097 4.59207 9.2332 -1.5037 0.999947 8.9462C3.77075 13.3003 12.8748 18.842 19.9998 8.9462Z",
    stroke: "#ADB84E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.35412,
    cy: 4.35412,
    r: 3.85412,
    transform: "matrix(-1 0 0 1 14.8621 4.59229)",
    stroke: "#ADB84E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.54125,
    cy: 1.54125,
    r: 1.54125,
    transform: "matrix(-1 0 0 1 12.2367 7.28638)",
    fill: "#ADB84E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5383 2.88527C17.6991 2.66075 18.0114 2.60906 18.2359 2.76982C18.4605 2.93058 18.5122 3.24291 18.3514 3.46744L17.5383 2.88527ZM16.2008 4.75335L17.5383 2.88527L18.3514 3.46744L17.0138 5.33552L16.2008 4.75335Z",
    fill: "#ADB84E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2522 1.00004C10.2522 0.723899 10.4761 0.500041 10.7522 0.500041C11.0283 0.500041 11.2522 0.723899 11.2522 1.00004L10.2522 1.00004ZM10.2522 3.29761L10.2522 1.00004L11.2522 1.00004L11.2522 3.29761L10.2522 3.29761Z",
    fill: "#ADB84E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42847 3.78627C2.24729 3.57787 2.26936 3.26206 2.47776 3.08088C2.68616 2.8997 3.00197 2.92177 3.18315 3.13017L2.42847 3.78627ZM3.93589 5.52019L2.42847 3.78627L3.18315 3.13017L4.69057 4.86409L3.93589 5.52019Z",
    fill: "#ADB84E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.193cf3fb07ca15e288384da518715441.svg";
export { ForwardRef as ReactComponent };